/**
 * Created by philipwells on 22/06/2017.
 */

    angular.module('qkr.default.products')
        .config(configDefaultProducts);

    configDefaultProducts.$inject = ['$routeSegmentProvider', 'appUrl'];

    function configDefaultProducts($routeSegmentProvider, appUrl) {
        $routeSegmentProvider
            .when('/defaultpatproducts', 'defaultpatproducts')
            .when('/defaultbartabproducts', 'defaultbartabproducts');

        $routeSegmentProvider
            .segment('defaultpatproducts', {
                template: require('../../default-products/templates/default.pat.products.html'),
                dependencies: ['outletId']})
            .segment('defaultbartabproducts', {
                template: require('../../default-products/templates/default.bar.tab.products.html'),
                dependencies: ['outletId']});
    }



// WEBPACK FOOTER //
// ./src/default-products/config/default.products.config.js